/* refonte-collection.js - genere depuis CLEAN-TWIN-COLLECTION.html - NE PAS EDITER A LA MAIN */
(function(){
  var RF = document.getElementById('rf-collection') || document;
  var doc = document.documentElement;
  doc.classList.add('js');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(){
    RF.querySelectorAll('[data-rv]').forEach(function(n){ n.classList.add('on'); });
  }

  /* 1. Reveal au scroll */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } });
  }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
  RF.querySelectorAll('[data-rv]').forEach(function(n){ io.observe(n); });

  /* Filet de sécurité : onglet caché ou IO inactif, on n'ampute jamais le contenu */
  if(rm || document.visibilityState === 'hidden') showAll();
  addEventListener('visibilitychange', function(){ if(document.visibilityState === 'hidden') showAll(); });
  setTimeout(function(){
    var last = RF.querySelectorAll('[data-rv]');
    if(last.length && !last[0].classList.contains('on')) showAll();
  }, 3000);

  /* 2. Filtres generiques : chaque bouton porte data-f (la facette) et data-v
        (la valeur) ; chaque carte porte data-<facette>="v1 v2". */
  var cards = [].slice.call(RF.querySelectorAll('#rf-grid .pc')),
      btns  = [].slice.call(RF.querySelectorAll('.fb')),
      cnt   = RF.querySelector('#rf-fcount'),
      none  = RF.querySelector('#rf-fnone'),
      state = {};
  btns.forEach(function(b){ if(!(b.dataset.f in state)) state[b.dataset.f] = 'all'; });

  function apply(){
    var n = 0;
    cards.forEach(function(c){
      var ok = true;
      Object.keys(state).forEach(function(k){
        if(state[k] === 'all') return;
        var have = (c.dataset[k] || '').split(' ');
        if(have.indexOf(state[k]) < 0) ok = false;
      });
      c.hidden = !ok;
      if(ok) n++;
    });
    if(cnt) cnt.textContent = n;
    if(none) none.classList.toggle('on', n === 0);
  }

  btns.forEach(function(b){
    b.addEventListener('click', function(){
      var f = b.dataset.f;
      state[f] = b.dataset.v;
      btns.forEach(function(x){ if(x.dataset.f === f) x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      apply();
    });
  });

  /* 3. Spotlight curseur du hero (desktop, hors reduced-motion) */
  var hero = RF.querySelector('#rf-hero');
  if(hero && !rm && matchMedia('(hover: hover)').matches){
    hero.classList.add('spot');
    var raf=0, x=50, y=28;
    hero.addEventListener('mousemove', function(e){
      var r=hero.getBoundingClientRect();
      x=((e.clientX-r.left)/r.width)*100; y=((e.clientY-r.top)/r.height)*100;
      if(!raf) raf=requestAnimationFrame(function(){ hero.style.setProperty('--mx',x+'%'); hero.style.setProperty('--my',y+'%'); raf=0; });
    }, {passive:true});
  }
})();
/* menu mobile */
(function(){
  var hd = document.querySelector('[id^="rf-"] .hd') || document.querySelector('.hd');
  if(!hd) return;
  var b = hd.querySelector('.brg');
  if(!b) return;
  b.addEventListener('click', function(){
    var open = hd.classList.toggle('is-open');
    b.setAttribute('aria-expanded', String(open));
    b.setAttribute('aria-label', open ? 'Chiudi il menu' : 'Apri il menu');
  });
  hd.querySelectorAll('.nav a').forEach(function(a){
    a.addEventListener('click', function(){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    });
  });
  document.addEventListener('click', function(e){
    if(hd.classList.contains('is-open') && !hd.contains(e.target)){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    }
  });
})();
